import { render, staticRenderFns } from "./AudioProcessor.vue?vue&type=template&id=a68210d8&scoped=true"
import script from "./AudioProcessor.vue?vue&type=script&lang=js"
export * from "./AudioProcessor.vue?vue&type=script&lang=js"
import style0 from "./AudioProcessor.vue?vue&type=style&index=0&id=a68210d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68210d8",
  null
  
)

export default component.exports